import DataTable from "@/components/application/data-table";
import SuperadminLayout from "@/components/superadmin/layout";
import useTranslations from "@/hooks/use-translations";
import { formatDate } from "@/lib/utils";
import { SuperadminUser } from "@/types";
import { ColumnDef } from "@tanstack/react-table";
import { ReactNode } from "react";

function useColumns(): ColumnDef<SuperadminUser>[] {
  const { t } = useTranslations("superadmin.users.index");

  return [
    {
      accessorKey: "email",
      header: t("table.email"),
    },
    {
      id: "name",
      header: t("table.name"),
      cell: ({ row }) =>
        [row.original.first_name, row.original.last_name]
          .filter(Boolean)
          .join(" ") || "—",
    },
    {
      accessorKey: "plan_slug",
      header: t("table.plan"),
      cell: ({ row }) => row.original.plan_slug ?? "—",
    },
    {
      accessorKey: "subscription_status",
      header: t("table.subscription_status"),
      cell: ({ row }) => row.original.subscription_status ?? "—",
    },
    {
      accessorKey: "stores_count",
      header: t("table.stores_count"),
    },
    {
      accessorKey: "created_at",
      header: t("table.created_at"),
      cell: ({ row }) => formatDate(row.original.created_at),
    },
  ];
}

function UsersPage({ users }: { users: SuperadminUser[] }) {
  const { t } = useTranslations("superadmin.users.index");
  const columns = useColumns();

  return (
    <div className="flex flex-col gap-6">
      <h2 className="font-semibold text-2xl">{t("title")}</h2>

      <DataTable<SuperadminUser> columns={columns} data={users} />
    </div>
  );
}

UsersPage.layout = (page: ReactNode) => <SuperadminLayout children={page} />;

export default UsersPage;
